module.exports = KsysAppTemplateV2dot5dot4;